import { Injectable } from '@angular/core';
//import Quill from 'quill';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Injectable({
  providedIn: 'root'
})
export class RichTextEditorService {
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
    minHeight: '100px',
    placeholder: 'Enter text here...',
    translate: 'no',
    //defaultParagraphSeparator: '',
    // defaultFontName: 'Arial',
    // defaultFontSize: '3',
    enableToolbar: false,
    showToolbar: false,
    
  };

  constructor() { }

  handleKeyDownEvent(event: KeyboardEvent): void {
    if (event.ctrlKey || event.metaKey) { // Check if the control or command key is pressed
      switch (event.key) {
        case 'b': // Prevent bold text
        case 'i': // Prevent italic text
        case 'u': // Prevent underlined text
        case 's': // Prevent strikethrough text
          event.preventDefault();
          break;
        default:
          break;
      }
    }
  }

  handlePasteEvent(event: ClipboardEvent): void {
    event.preventDefault();
    const text = event.clipboardData?.getData('text/plain') || '';
    document.execCommand('insertText', false, text);
  }

}